export default "__VITE_ASSET__2$ARrq7b__"